import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { base_path } from "./environment"
import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import "../src/style/css/feather.css"
import "../src/index.scss"
import store from "./core/data/redux/store"
import { Provider } from "react-redux"
import "../src/style/icon/boxicons/boxicons/css/boxicons.min.css"
import "../src/style/icon/weather/weathericons.css"
import "../src/style/icon/typicons/typicons.css"
import "../src/style/icon/fontawesome/css/fontawesome.min.css"
import "../src/style/icon/fontawesome/css/all.min.css"
import "../src/style/icon/ionic/ionicons.css"
import "../src/style/icon/tabler-icons/webfont/tabler-icons.css"
import ALLRoutes from "./feature-module/router/router"
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js"
import "react-toastify/dist/ReactToastify.css"
import { ToastContainer } from "react-toastify"

// Configure Bootstrap Dropdown to use Popper's 'fixed' strategy globally.
// This prevents dropdowns inside tables (e.g. Action 3-dots menus) from being
// clipped by table overflow containers or triggering unwanted vertical scrollbars.
if (typeof window !== "undefined") {
  const bs = (window as any).bootstrap
  if (bs?.Dropdown?.Default) {
    bs.Dropdown.Default.popperConfig = { strategy: "fixed" }
  }
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename={base_path}>
        <ALLRoutes />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          // Default top-right offset (1em) sits inside the fixed 56px header
          // (.header in _header.scss), overlapping the search bar/campus
          // selector -- most visible when 2+ toasts stack (e.g. bulk print's
          // "N subjects skipped" + a popup-blocked error together).
          style={{ top: "72px" }}
        />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
)
